import { defineStore } from "pinia";
import { getI18n } from "@/plugins/i18n";

const fallbackMessage = "You are not authorized to access this page.";

function getDefaultMessage() {
  const translated = getI18n().global.t("alkokh.errors.notAuthorizedWarning");

  return translated === "alkokh.errors.notAuthorizedWarning"
    ? fallbackMessage
    : translated;
}

export const useAuthorizationWarningStore = defineStore("authorization-warning", {
  state: () => ({
    visible: false,
    message: "",
  }),
  actions: {
    show(message?: string) {
      this.message = message?.trim() || getDefaultMessage();
      this.visible = true;
    },
    dismiss() {
      this.visible = false;
    },
  },
});
